import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

export function ErrorPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <AlertTriangle className="h-12 w-12 text-destructive" />
      <h1 className="text-2xl font-bold">Une erreur est survenue</h1>
      <p className="text-muted-foreground max-w-md">
        L'application a rencontre un probleme inattendu. Veuillez recharger la page.
      </p>
      <Button onClick={() => window.location.reload()}>
        Recharger la page
      </Button>
    </div>
  );
}
